module.exports = __webpack_public_path__ + "img/ios_download_btn.b3b976c7.png";